import { Accordion, Text } from '@betterment/samba-react';

const VestingAccordion: React.FC = () => {
  return (
    <Accordion type="single" collapsible={true}>
      <Accordion.Item value="item-1" css={{ border: 'none' }}>
        <Accordion.Trigger css={{ padding: 'space.0' }}>Your match vests</Accordion.Trigger>
        <Accordion.Content css={{ padding: 'space.150', ml: 'space.200' }}>
          <Text variant="text100">
            These matched dollars will become yours over a period of time depending on your company’s plan rules. You
            can check with your employer to determine your company’s specific vesting schedule. All contributions that
            you make to the plan through payroll are owned by you completely. Only employer match dollars are subject to
            vesting.
          </Text>
        </Accordion.Content>
      </Accordion.Item>
    </Accordion>
  );
};

export default VestingAccordion;
